import { produce } from 'immer';
import * as types from './addEditModuleTypes';
import createReducer from '../utils/createReducer';

const initialState = {
    // Widget editor visibility
    isOpen: false,

    // Widget editor configuration
    config: {
        context: null,
        eventId: '',
        pageId: '',
        activePage: null,
        pageName: '',
        selectedModule: null,
        widgetId: null,
        fetchData: null,
        isMenuPage: false,
        isDefaultLink: false,
        isConfigurable: false,
        isShowAudience: false,
        isWebDesigner: false,
        parentWidgetId: null,
        width: '300px',
        PageDetail: null,
        getTargetAudienceUpdateOptions: null,
    },

    // Loading states
    isLoading: false,

    // Error states
    error: null,
};

const actionHandlers = {
    [types.OPEN_WIDGET_EDITOR]: produce((draft, { payload }) => {
        draft.isOpen = true;
        draft.config = {
            ...draft.config,
            ...payload,
        };
        draft.error = null;
    }),

    [types.CLOSE_WIDGET_EDITOR]: produce((draft) => {
        draft.isOpen = false;
        // Keep config for potential reopen, but reset sensitive data
        draft.config.widgetId = null;
        draft.config.selectedModule = null;
        draft.config.parentWidgetId = null;
        draft.error = null;
    }),

    [types.UPDATE_WIDGET_CONFIGURATION]: produce((draft, { payload }) => {
        draft.config = {
            ...draft.config,
            ...payload,
        };
    }),

    [types.SET_WIDGET_CONTEXT]: produce((draft, { payload }) => {
        draft.config.context = payload;
    }),

    [types.RESET_WIDGET_EDITOR]: produce((draft) => {
        draft.isOpen = false;
        draft.config = { ...initialState.config };
        draft.isLoading = false;
        draft.error = null;
    }),
};

export default createReducer(initialState, actionHandlers);
